$(document).on('click', '.js-spoiler-trigger', function (e) {
	e.preventDefault();
	let $btn = $(this);
	let text = $btn.text();
	let label = $btn.data('label');
	$btn.text(label).data('label', text);

	$(this).toggleClass('active');
	$(this).parent().find('.spoiler__content').slideToggle(300);
})



// WEBPACK FOOTER //
// ./frontend/components/spoiler/spoiler.js